import { useI18nNamespace as useCoreI18nNamespace } from "@braze/i18n-core";
import type { UseI18nNamespace } from "@braze/i18n-core";

import type { MessageValues } from "../../../../../types/translations";

export const useI18nNamespace: UseI18nNamespace<MessageValues> = useCoreI18nNamespace;
